/**
 * TEMPORARY: Region-specific details for Lunar New Year site takeover only.
 * Used because LAB cannot currently set content per region.
 * Remove when LAB supports region-based messaging or after lunar-new-year campaign ends.
 *
 * Theme id must be exactly "lunar-new-year" (from siteTakeoverTheme.id).
 */

export const LUNAR_NEW_YEAR_THEME_ID = 'lunar-new-year'

interface LunarNewYearRegionAmounts {
  silverAmount: string
  goldAmount: string
}

const LUNAR_NEW_YEAR_AMOUNTS_BY_REGION: Readonly<Record<string, LunarNewYearRegionAmounts>> = {
  SG: { silverAmount: 'S$1,000', goldAmount: 'S$3,000' },
  MY: { silverAmount: 'RM3,200', goldAmount: 'RM9,500' },
  HK: { silverAmount: 'HK$6,000', goldAmount: 'HK$18,200' },
  ZA: { silverAmount: 'ZAR13,000', goldAmount: 'ZAR38,000' },
}

/**
 * Returns region-specific loyalty spend amounts for the Lunar New Year campaign, or undefined if none for this region.
 * @param regionCode - current region code (e.g. from GeoContext), case-insensitive for lookup
 */
export function getLunarNewYearRegionAmounts(
  regionCode: string | undefined,
): LunarNewYearRegionAmounts | undefined {
  if (!regionCode) {
    return undefined
  }
  const key = regionCode.toUpperCase()
  return LUNAR_NEW_YEAR_AMOUNTS_BY_REGION[key]
}
